import { Employee, isProdMode, UserEnum } from "./app-common";

/**
 * Checks whether the given `id` exists in the `accessList`.
 * In production mode, access is restricted to Mateen and Praneeth only.
 * @param accessList - Array of allowed Employee or UserEnum IDs.
 * @param id - ID to check.
 * @returns True if access is allowed, false otherwise.
 */
export function isAccess(accessList: (Employee | UserEnum)[], id: number): boolean {
    if (!id) return false;
    if (!isProdMode()) {
        const prodAllowed = [Employee.MATEEN_DEV, Employee.PRANEETH_DEV, UserEnum.MANAGER];
        return prodAllowed.includes(id);
    }

    return accessList.includes(id);
}

// Employees with permission to block/unblock customers
// [3104,30103,3021,2697]
export const customerBlockUnBlockAccess: Employee[] = [
    Employee.AMIR_GHAAFFAR,
    Employee.BANDER_ALLAFI,
    Employee.ANANDHAN_NAGARAJAN,
    Employee.KAUSHIK_SAMPAT,
    Employee.NOHA_KARKADAN,
    Employee.SATHISH_KUMAR,
    Employee.ABDELRAHMAN,
    Employee.Abdulrahman_ElShafai,
];

export const consigneeAddressChangeAccess: UserEnum[] = [
    UserEnum.MANAGER,
    UserEnum.OPS_MANAGER,
    UserEnum.OPERATION_SUPERVISOR,
    UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR, // OS & CC
    UserEnum.OPERATION_CS_SUPERVISOR, // Operation CS User
    UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF, // Operation Supervisor & CC
    UserEnum.OPERATION_STAFF,
];

export const FTE_CONFIGURATION_ACCESS: Employee[] = [
    Employee.ASIF_PATEL,
    Employee.PANDI,
    Employee.MUZAMMIL_KHAN,
    Employee.Muhammed_Ahmed_Khan,
    Employee.Khalid_Ajlan_Alharthi,
    Employee.SHIVRIN, Employee.MOHAMMED_LUQMAN,
];

export const GeoFencingAccess: Employee[] = [
    Employee.MATEEN_PROD,
    Employee.PANDI,
    Employee.ARJUN_KUMAR,
    Employee.MAHTAB_ALI
    , Employee.PRANEETH
];


export const NotificationEnabledRoles: UserEnum[] = [
    UserEnum.OPS_MANAGER,
    UserEnum.OPERATION_SUPERVISOR,
    UserEnum.OPERATION_CS_SUPERVISOR,
    UserEnum.OPERATION_STAFF,
    UserEnum.OPERATOR_CASH_COLLECTOR,
    UserEnum.OPERATION_SUPERVISOR_CASH_COLLECTOR,
    UserEnum.OCC_SOLUTION,
    UserEnum.OPERATION_SUPERVISOR_OPERATION_STAFF,
    UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER,
]

export const AdhocTripTabRoles = {
    positionId: [],
    employeeIds: [
        // DRY
        Employee?.MAJAD_ALI,
        2776,   // Vysakh (DMM)
        3229,   // Muhammed Rizwan (RUH)
        2705,   // Surendran (RUH)
        900431, // Mujahid Kareem (RUH)
        2123,   // Muhammed Sami (RUH)
        2816,   // Jameel Hussain (JED)
        1403,   // M. Luqman (JED)
        2312,   // Jijo (JED)
        1008, //Muhammed Nabeel
        1482,  //Faisal Alahmri
        // Cold
        Employee?.SHIVRIN,
        901064, // Jayson S Asuncion (Dammam)
        3102,   // Muhammed Ahmed Khan (Riyadh)
        Employee.Khalid_Ajlan_Alharthi, // 3339 Khalid Ajlan Alharthi
        783,    // Shajahan Shamsudeen (Jeddah)
        // UAE
        Employee?.IMATHUL_RAFI,
        684,
        2846,//Hassan Almirza
        Employee.Khaznah_Aldossari,
        601,
        Employee.MOHAMMAD_SHABAZ // 3286 - Adhoc full access
    ]
};

export const AdhocVendor_TripApproval_Roles = {
    positionId: [],
    employeeIds: [
        // DRY
        Employee?.MAJAD_ALI,
        // Cold
        Employee?.SHIVRIN, Employee?.MOHAMMED_LUQMAN,
        // UAE
        Employee?.IMATHUL_RAFI,
        2846,//Hassan Almirza
        Employee.Khaznah_Aldossari,
        601,
        684,
        Employee.MOHAMMAD_SHABAZ // 3286 - Adhoc full access
    ]
};

// Employees outside the OCC / Customer Care roles who can access Demurrage Charges > OCC Approval
export const DEMURRAGE_OCC_APPROVAL_ACCESS: Employee[] = [
    Employee.MOHAMMAD_SHABAZ,
];

/**
 * Core group that shares ALANOUD's access across the app.
 * Add new employees here — every place using this constant gets updated automatically.
 */
export const PRICING_TEAM_ACCESS: Employee[] = [
    Employee.MATEEN_PROD,
    Employee.ALANOUD,
    Employee.FARAH,
    Employee.ELAF_SARHAN,
    Employee.ASHWAQ_ALANEZ,
];

export const AGREEMENT_PRICING_ACCESS: Employee[] = [
    ...PRICING_TEAM_ACCESS,
]


